import { Modal as BaseModal } from "@wrstudios/components";
import styled, { css } from "styled-components";
import { default as BaseButton } from "../Button";
import { Container as BaseTextareaStyle } from "../styled/text-area";

export const ModalHeader = styled(BaseModal.Header)`
  font-size: 2.1rem;
  margin: auto;
`;

export const ModalContent = styled(BaseModal.Content)`
  width: 100%;
  max-width: 60rem;
`;

export const Emoticons = styled(BaseModal.Body)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3.2rem;
  padding-top: 2rem;
  padding-bottom: 1rem;
`;

export const Emoticon = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  outline: none;

  ${({ active }) =>
    active &&
    css`
      svg path {
        fill: ${({ theme }) => theme.styleGuide.colors.helix["sec-orange"]};
      }
    `}

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.styleGuide.colors.helix["sec-orange"]};
    }
  }

  &:focus {
    outline: 0.2rem solid
      ${({ theme }) => theme.styleGuide.colors.helix["sec-orange"]};
    outline-offset: 0.5rem;
    border-radius: 0.4rem;
  }

  span {
    text-transform: uppercase;
    font-size: 1.2rem;
  }
`;

export const Comment = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;

  p {
    font-size: 1.2rem;
    margin-top: -0.6rem;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: -1rem;

  ${({ theme }) => theme.media.sm`
    flex-direction: column;
    margin: -0.5rem;
  `};
`;

export const Action = styled.div`
  padding: 1rem;

  ${({ theme }) => theme.media.sm`
    width: 100%;
    padding: 0.5rem;
  `};
`;

export const Button = styled(BaseButton)`
  ${({ theme }) => theme.media.sm`
    width: 100%;
  `};
`;

export const Icon = styled.span`
  display: inline-flex;
  margin-right: 0.5rem;

  svg {
    width: 1.8rem;
    height: 1.8rem;
  }
`;

export const TextArea = styled(BaseTextareaStyle)`
  width: 100%;
  height: 65px;
  margin: 1rem 0;
  resize: none;
`;

export const Hint = styled.p`
  color: ${({ theme }) => theme.styleGuide.colors.helix["sec-orange"]};
  font-size: 1.3rem;
  margin-top: 1rem;
  margin-bottom: -1.5rem;
`;

export const Checkbox = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;

  &:focus-within {
    .helix-checkbox__input {
      outline: 3px solid var(--helix-gray-200);
      box-shadow: 0 0 0 0.5px
        ${({ theme }) => theme.styleGuide.colors.gray[700]};
    }
  }

  label {
    display: inline-flex;
    align-items: center;

    div {
      width: 16px;
      flex: 0 0 16px;
      height: 16px;
      position: relative;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-right: 12px;
      background-color: #fff;
      border-radius: 4px;
      border: solid 1px ${({ theme }) => theme.styleGuide.colors.gray[700]};
      box-shadow: 0 0 0 0.5px
        ${({ theme }) => theme.styleGuide.colors.gray[700]};
    }

    input[type="checkbox"] {
      width: 0;
      height: 0;
      -webkit-appearance: none;
    }

    input[type="checkbox"]:checked + div {
      &:before {
        content: "";
        position: absolute;
        width: 16px;
        height: 16px;
        border: solid 1.5px
          ${({ theme }) => theme.styleGuide.colors.helix["brand"]};
        box-shadow: 0 0 0 0.5px
          ${({ theme }) => theme.styleGuide.colors.helix["brand"]};
        border-radius: 4px;
        background-color: ${({ theme }) =>
          theme.styleGuide.colors.helix["brand"]};
      }

      &:after {
        content: "";
        background-image: url("data:image/svg+xml,%3Csvg className='helix-checkbox__checkmark' fill='none' height='6' viewBox='0 0 8 6' width='8' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M1 3L3 5L7 1' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' /%3E%3C/svg%3E");
        color: #fff;
        position: absolute;
        width: 10px;
        height: 10px;
        top: 3px;
        box-sizing: border-box;
        background-size: contain;
        background-repeat: no-repeat;
      }

      &:hover {
        &:before {
          border-color: ${({ theme }) =>
            theme.styleGuide.colors.helix["brand"]};
        }
      }
    }
  }
`;
